import React from "react"
import LazyLoad from 'react-lazy-load'

const RolexApp = (props) => {
    return(
        <LazyLoad offsetVertical={400} height="100%" width="100%">
            <>
                {props.linkBlock ? (
                    <>
                        <iframe src="https://static.rolex.com/clocks/2023/thechevronchampionship_desk_HTML_315x200/rolex.html"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: 0,
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                                scroll: "none"
                            }}
                            className="d-none d-xxl-block"
                            title="Rolex"
                            scrolling="no"
                            loading="lazy"
                        />

                        <iframe src="https://static.rolex.com/clocks/2023/thechevronchampionship_tablet_HTML_260x200/rolex.html"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: 0,
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                                scroll: "none"
                            }}
                            className="d-none d-sm-block d-xxl-none"
                            title="Rolex"
                            scrolling="no"
                            loading="lazy"
                        />

                        <iframe src="https://static.rolex.com/clocks/2023/thechevronchampionship_mobile_HTML_320x90/rolex.html" 
                            style={{
                                width: "100%",
                                height: "90px",
                                border: 0,
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                                scroll: "none"
                            }}
                            className="d-sm-none"
                            title="Rolex"
                            scrolling="no"
                            loading="lazy"
                        />
                    </>
                ) : (
                    <iframe src="https://static.rolex.com/clocks/2023/thechevronchampionship_tablet_HTML_260x200/rolex.html"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: 0,
                            margin: 0,
                            padding: 0,
                            overflow: "hidden",
                            scroll: "none"
                        }}
                        title="Rolex"
                        scrolling="no"
                        loading="lazy"

                    />
                )}
            </>
        </LazyLoad>
    )
}


export default RolexApp